import { StructureDemo } from "util/instance";
import { makeAssetUrl } from "util/util";

export function EditChannelFullDemo() {
    const modulePublic = {
        channel: {
            all: {
                channel1: {
                    from: "a",
                    isDefault: true,
                    key: "channel1",
                    name: "Channel 1",
                    photoUrl: makeAssetUrl("faces/robo.jpeg"),
                },
            },
            "instanceToChannel": {},
        },
    };
    
    return (
        <StructureDemo
            structureKey={"channel"}
            instanceKey={"channel1"}
            screenKey={"edit"}
            testState={{ modulePublic }}
        />
    );
}